import { lazyNamed } from 'src/utils/lazyNamed.ts';

const OverviewV2 = {
  Page: lazyNamed(() => import('./Page.tsx'), 'Page'),
};

export default OverviewV2;
